import { useState } from "react";
import axios from "axios";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { API, errMsg, euro } from "@/lib/api";
import { StatusBadge } from "@/pages/Account";

export default function ManageBooking() {
  const [code, setCode] = useState("");
  const [email, setEmail] = useState("");
  const [b, setB] = useState(null);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const lookup = async (e) => {
    e.preventDefault();
    setErr("");
    if (code.trim().length < 4 || !email.includes("@")) return setErr("Introduce tu código y tu correo.");
    setBusy(true);
    try {
      setB((await axios.post(`${API}/bookings/lookup`, { code, email })).data);
    } catch (e) {
      setB(null);
      setErr(errMsg(e));
    } finally {
      setBusy(false);
    }
  };

  const cancel = async () => {
    if (!window.confirm("¿Seguro que quieres cancelar esta cita?")) return;
    setBusy(true);
    try {
      const r = (await axios.post(`${API}/bookings/cancel-by-code`, { code, email })).data;
      setB({ ...r, can_cancel: false });
      toast.success("Cita cancelada");
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };

  const input = "mt-2 w-full h-12 px-4 border border-zinc-300 outline-none focus:border-[#111111]";
  return (
    <section className="max-w-xl mx-auto px-4 sm:px-6 py-16 sm:py-24" data-testid="manage-booking-page">
      <p className="text-xs tracking-[0.3em] uppercase text-zinc-500">Gestionar reserva</p>
      <h1 className="font-serif text-4xl sm:text-5xl tracking-tight mt-3 mb-10">Consulta tu cita</h1>
      <form onSubmit={lookup} className="space-y-5" noValidate>
        <label className="block"><span className="text-xs tracking-[0.2em] uppercase text-zinc-500">Código de reserva</span>
          <input value={code} onChange={(e) => setCode(e.target.value.toUpperCase())} placeholder="P7-XXXXXX" className={`${input} font-mono`} data-testid="manage-code-input" /></label>
        <label className="block"><span className="text-xs tracking-[0.2em] uppercase text-zinc-500">Correo electrónico</span>
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} className={input} data-testid="manage-email-input" /></label>
        {err && <p className="text-sm text-red-600" data-testid="manage-error">{err}</p>}
        <button disabled={busy} className="h-12 px-8 bg-[#111111] text-white text-xs tracking-[0.2em] uppercase inline-flex items-center gap-2 disabled:opacity-60" data-testid="manage-lookup-button">
          {busy && <Loader2 className="w-4 h-4 animate-spin" />} Buscar
        </button>
      </form>
      {b && (
        <div className="mt-10 border border-zinc-200 p-6 space-y-2" data-testid="manage-result">
          <div className="flex justify-between items-center"><span className="font-mono">{b.code}</span><StatusBadge status={b.status} testid="manage-status" /></div>
          <p className="font-semibold">{b.service_name} · {euro(b.amount_due)}</p>
          <p className="text-sm text-zinc-600">{b.date_label} · {b.start}</p>
          {b.can_cancel ? (
            <button onClick={cancel} disabled={busy} className="mt-4 text-sm underline hover:text-red-600" data-testid="manage-cancel-button">Cancelar cita</button>
          ) : (
            ["pending", "confirmed"].includes(b.status) && <p className="text-xs text-zinc-500 mt-4">Las citas solo pueden cancelarse online hasta {b.cancel_hours} h antes. Contacta con el salón.</p>
          )}
        </div>
      )}
    </section>
  );
}
